import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ConfigurationService } from './configuration.service';
import { LocalStorageService } from './local-storage.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  paramIds = new Set();

  constructor(
    private configService: ConfigurationService,
    private localStorage: LocalStorageService
  ) {

  }

  private handleAuthError(errResponse: HttpErrorResponse): Observable<any> {

    let errorMessage = '';
    /* istanbul ignore if */
    if (errResponse.error instanceof ErrorEvent) { // client-side error

      errorMessage = `Error: ${errResponse.error.message}`;

      return throwError(errResponse);

    } else {
      if (errResponse.status == 401) {
        return throwError({
          status: 401,
          message: 'Session expired. Please login again.'
        });
      }
      return throwError(errResponse);
    }
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let bearerToken = this.localStorage.getToken();
    let appname = this.localStorage.getPortal();
    if (!bearerToken || bearerToken === 'undefined' ||
      request.url.includes('sso/verifytoken')) {
      return next.handle(request).pipe(
        catchError(err => this.handleAuthError(err))
      );
    } else {
      

      if (request.url.includes('silo') && !request.headers?.has('content-type')) {
        request = request.clone({
          setHeaders: {
            'content-type': 'text/zinc'
          }
        });
      }

      /* istanbul ignore else */
      if (bearerToken && bearerToken !== 'undefined') {

        const tokenReq = request.clone({
          setHeaders: {
            Authorization: `Bearer ${bearerToken}`,
            '75F-Application': appname || ''
          }
        });

        return next.handle(tokenReq)
          .pipe(
            catchError(err => this.handleAuthError(err))
          );
      } else {
        return next.handle(request).pipe(
          catchError(err => this.handleAuthError(err))
        );
      }
    }
  }
}


